React = require 'react'
t = require('views/internal/recup-with-helpers')('org_members')
OrganizationMembersItemComponent = require 'views/organization/organization-members-item-component'
OrganizationMembersListComponent = require 'views/organization/organization-members-list-component'

module.exports = class OrganizationGuestListComponent extends React.Component
  render: t.renderable ->
    { memberItems,
      memberTypeFilter,
      orgIsBC
    } = @props

    orgType = if orgIsBC then 'bc' else 'free'

    t.div ->
      multiboardGuests = memberItems.filter((guest) -> guest.boardCount > 1)
      singleBoardGuests = memberItems.filter((guest) -> guest.boardCount == 1)

      if multiboardGuests.length > 0 ||
         (singleBoardGuests.length == 0 && multiboardGuests.length == 0)
        t.div '.org-guest-section', ->
          t.h3 ->
            t.format "multi-board-guests", {
              count: multiboardGuests.length,
              className: '.org-members-space-right'
            }
            if orgIsBC
              t.icon 'business-class'
          t.p -> t.format "#{orgType}-multi-board-guests-are-members-of", {
            learnMoreLink: '/business-class'
          }
          t.addElement React.createElement OrganizationMembersListComponent, {
            memberItems: multiboardGuests
            memberTypeFilter
          }

      if singleBoardGuests.length > 0 ||
         (singleBoardGuests.length == 0 && multiboardGuests.length == 0)
        t.div '.org-guest-section', ->
          t.h3 -> t.format "single-board-guests", { count: singleBoardGuests.length }
          t.p -> t.format "#{orgType}-single-board-guests-are-members-of"
          t.addElement React.createElement OrganizationMembersListComponent, {
            memberItems: singleBoardGuests
            memberTypeFilter
          }



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-guest-list-component.coffee